import { Injectable, Inject, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { Api } from '../api/api';
import { AfsProvider } from '../afs/afs';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { Events } from '../events';
//import * as firebase from 'firebase/compat/app';
//import undefined from 'firebase/compat/messaging'; 

import { FCM } from '@capacitor-community/fcm';
import { PushNotifications, PushNotificationSchema, ActionPerformed, Channel } from '@capacitor/push-notifications';


declare let window: any;

@Injectable()
export class FcmProvider {

  user$: Observable<any>;
  currentMessage = new BehaviorSubject(null);
  notifications: PushNotificationSchema[] = [];
  //private messaging: firebase.default.messaging.Messaging;

  constructor(
    private platform: Platform,
    private api: Api,
    private afsProvider: AfsProvider,
    private afMessaging: AngularFireMessaging,
    private events: Events,
    private zone: NgZone
    //@Inject(FirebaseApp) private _firebaseApp: firebase.default.app.App
  ) {

    //this.messaging = firebase.default.messaging(this._firebaseApp);

    this.events.subscribe('unregisterFCM', (user) => {
      this.unRegisterRedButtonAlarm(user);
    });
  }


  createChannel() {
    const channel:Channel = {
      // channel ID - must be unique per app package
      id: 'hnr.alert.input',

      // Channel description. Default: empty string
      description: 'Alarmeingang',

      // Channel name. Default: empty string
      name: 'Alarmeingang',

      // The sound to play once a push comes. Default value: 'default'
      // Values allowed:
      // 'default' - plays the default notification sound
      // 'ringtone' - plays the currently set ringtone
      // 'false' - silent; don't play any sound
      // filename - the filename of the sound file located in '/res/raw' without file extension (mysound.mp3 -> mysound)
      sound: 'notification',

      // Vibrate on new notification. Default value: true
      // Possible values:
      // Boolean - vibrate or not
      // Array - vibration pattern - e.g. [500, 200, 500] - milliseconds vibrate, milliseconds pause, vibrate, pause, etc.
      vibration: true,

      // Whether to blink the LED
      lights: true,

      // LED color in ARGB format - this example BLUE color. If set to -1, light color will be default. Default value: -1.
      lightColor: parseInt('FF0000FF', 16).toString(),

      // Importance - integer from 0 to 4. Default value: 4
      // 0 - none - no sound, does not show in the shade
      // 1 - min - no sound, only shows in the shade, below the fold
      // 2 - low - no sound, shows in the shade, and potentially in the status bar
      // 3 - default - shows everywhere, makes noise, but does not visually intrude
      // 4 - high - shows everywhere, makes noise and peeks
      importance: 4,

      // Show message on locked screen. Default value: 1
      // Possible values (default 1):
      // -1 - secret - Do not reveal any part of the notification on a secure lockscreen.
      // 0 - private - Show the notification on all lockscreens, but conceal sensitive or private information on secure lockscreens.
      // 1 - public - Show the notification in its entirety on all lockscreens.
      visibility: 1
    };

    return PushNotifications.createChannel(channel);
  }

  getFirebaseToken(): Promise<any> {
    return new Promise((resolve) => {
      if (!window.FirebasePlugin) {
        resolve(null);
        return;
      }
      window.FirebasePlugin.getToken((token) => {
        resolve(token);
      }, (error) => {
        resolve(error);
      });
    });
  }

  checkPermission(): Promise<any> {
    return new Promise(async (resolve) => {
      await PushNotifications.requestPermissions();
      await PushNotifications.register();
      resolve(true);
    });
  }

  // Get permission from the user
  async getToken(userData: any) {
    return new Promise(async (resolve) => {
      let token: any;

      if (this.platform.is('android')) {
        try{
          token = await FCM.getToken();
          token = token.token;
        } catch(err) {
          alert("FCM getToekn");
          alert(JSON.stringify(err));
        }
        
        try{
          await this.createChannel();
        } catch (err) {
          alert(JSON.stringify(err));
        }

        await this.checkPermission();
        
      }
      else if (this.platform.is('ios')) {
        token = await FCM.getToken();
        await this.checkPermission();
      } else {

        token = await new Promise((resolve, reject) => {
          this.afMessaging.requestPermission
            .pipe(mergeMapTo(this.afMessaging.tokenChanges))
            .subscribe(
              (token2) => { console.log('Permission granted!', token2); resolve(token2); },
              (error) => { console.error(error); reject(); },
            );
        });
      }

      resolve(token);

      this.saveTokenToFirestore(token, userData);

    });
  }

  // Save the token to firestore
  private saveTokenToFirestore(token: string, userData: any) {

    if (!token) { return; }
    this.registerRedButtonAlarm(token);
    this.api.updateHnrToken('alertPush', true);
    this.api.updateProfile('profile.deviceFCMToken', { value: token }).subscribe({next:() => {
    }, error: (err) => {
      console.log(err);
    }});

    this.afsProvider.writeTokenToDatabase(token, userData);


  }

  registerRedButtonAlarm(token = '') {
    if (this.platform.is('android') || this.platform.is('ios')) {

      if (this.api._user.profile.alertGroups) {
        this.api._user.profile.alertGroups.forEach(element => {
          PushNotifications.register().then((_) => {
            FCM.subscribeTo({ topic: this.api._user.provider + '-' + element }).then((message) => {
              console.log("after subscribeTo");
              console.log(message);
            });
          }).catch((err) => alert(JSON.stringify(err)));


        });
      } else {
        PushNotifications.register().then((_) => {
          FCM.subscribeTo({ topic: this.api._user.provider + '-redButtonAlarm' });
        }).catch((err) => alert(JSON.stringify(err)));
      }
    } else {
      if (!token && this.api._user.profile.deviceFCMToken) {
        token = this.api._user.profile.deviceFCMToken;
      }

      if (!token) {
        return;
      }
      if (this.api._user.profile.alertGroups) {
        this.api._user.profile.alertGroups.forEach(element => {
          this.api.put('firebaseRegisterTopic', { token, topic: this.api._user.provider + '-' + element }).subscribe(() => {

          }, (err) => {
            console.log(err);
          });
        });
      } else {
        this.api.put('firebaseRegisterTopic', { token, topic: 'redButtonAlarm' });
      }
    }
  }

  unRegisterRedButtonAlarm(user: any = null) {
    user = user || this.api._user.provider;

    if (this.platform.is('android') || this.platform.is('ios')) {
      if (user.profile.alertGroups) {
        user.profile.alertGroups.forEach(element => {
          FCM.unsubscribeFrom({ topic: user.provider + '-' + element })
        });
      } else {
        FCM.unsubscribeFrom({ topic: user.provider + '-redButtonAlarm' })
      }
    } else {
      if (user.profile.alertGroups) {
        user.profile.alertGroups.forEach(element => {
          this.api.delete('firebaseUnregisterTopic', { token: user.profile.deviceFCMToken, topic: user.provider + '-' + element }).subscribe((data) => {
            console.log(data);
          }, (err) => {
            console.log(err);
          });
        });
      } else {
        this.api.delete('firebaseUnregisterTopic', { token: user.profile.deviceFCMToken, topic: user.provider + '-redButtonAlarm' });
      }
    }
  }

  onBackgroundMessage(): Observable<any> {
    return new Observable((observer) => {
        PushNotifications.addListener("pushNotificationActionPerformed",
          (notification: ActionPerformed) => {
            observer.next(notification.notification.data);
            //alert("Push action performed: " + JSON.stringify(notification));
          }
        );
    });
  }

  onBackgroundMessageBrowser(): Observable<any> {
    return new Observable((observer) => {
      // this.messaging.onBackgroundMessage((message:any)=>{
      //     console.log(message);
      //     observer.next(message.data);
      // });
    });
  }



  onForegroundMessage(): Observable<any> {
    return new Observable((observer) => {
      window.FirebasePlugin.onMessageReceived((message) => {
        console.log('Message type: ' + message.messageType);
        if (message.messageType === 'notification') {
          console.log('Notification onForegroundMessage message received');
          if (message.tap === 'foreground') {
            observer.next(message);
          }
        }
        console.dir(message);
      }, (error) => {
        console.error(error);
      });
    });
  }

  // Listen to incoming FCM messages
  listenToNotificationsBackground(): any {
    return this.onBackgroundMessage();
  }

  listenToNotificationsForeground(): any {
    return this.onForegroundMessage();
  }

  start() {
    return new Promise((resolve) => {
      if (this.platform.is('android') || this.platform.is('ios')) {

        PushNotifications.addListener('registration', (data) => {
          console.log(data);
        });
        PushNotifications.addListener('registrationError', (data) => {
          alert(JSON.stringify(data));
        });
        PushNotifications.addListener(
          'pushNotificationReceived',
          (notification: PushNotificationSchema) => {
            console.log('notification ' + JSON.stringify(notification));
            this.zone.run(() => {
              this.notifications.push(notification);
            });
          }
        );

        PushNotifications.requestPermissions().then((response) =>
          PushNotifications.register().then(() => {resolve(response); })
        );

      } else {
        resolve(true);
      }
    });

  }

}
